import {
  RequestDetailsContainerDivider,
  RequestDetailsContainerStyle,
  RequestDetailsContentContainer,
  RequestDetailsCloseButton,
  CancelButton,
  ButtonsContainer,
} from './styles/RequestDetailsContainer.styled';
import { RequestDetailsHeader } from './RequestDetailsHeader';
import { RequestDetailsInfoContainer } from './RequestDetailsInfoContainer';
import { RequestDetailsApprovalContainer } from './RequestDetailsApprovalContainer';
import { VacationsRequest } from '../models/RequestDetails.interface';
import { CalendarCancelLight } from './styles/RequestDetailsHeader.styled';
import { StatusEnum } from 'src/utils/mappers/checkStatusCode';
import { VacationTypes } from 'src/tabs/constants/Timeoff.constants';

interface RequestDetailsContainerProps {
  hideRequestPopup: () => void;
  requestDetails: VacationsRequest;
  showCancelPopup: () => void;
}

export const RequestDetailsContainer = ({
  hideRequestPopup,
  requestDetails,
  showCancelPopup,
}: RequestDetailsContainerProps) => {
  const isVacationType =
    requestDetails?._new_vacationtype_value_Formatted ===
      VacationTypes.PAID_VACATION ||
    requestDetails?._new_vacationtype_value_Formatted ===
      VacationTypes.UNPAID_VACATION ||
    requestDetails?._new_vacationtype_value_Formatted ===
      VacationTypes.PAID_VACATION_BONUS_DAYS;
  const isVacationStatus =
    requestDetails?.statuscode_Formatted === StatusEnum.WAITING_FOR_APPROVAL ||
    requestDetails?.statuscode_Formatted === StatusEnum.PROCESSED ||
    requestDetails?.statuscode_Formatted === StatusEnum.NEW;
  const isDateGreater = new Date(requestDetails?.new_startdate) > new Date();

  const isCancelDisplayed = isVacationStatus && isVacationType && isDateGreater;
  return (
    <RequestDetailsContainerStyle role="document">
      <RequestDetailsHeader
        vacationStatus={requestDetails?.statuscode_Formatted}
        hideRequestPopup={hideRequestPopup}
      />
      <RequestDetailsContentContainer>
        <RequestDetailsInfoContainer
          creationDate={requestDetails?.createdon}
          vacationType={requestDetails?._new_vacationtype_value_Formatted}
          vacationStatus={requestDetails?.statuscode_Formatted}
          startDate={requestDetails?.new_startdate}
          endDate={requestDetails?.new_enddate}
          numWorkDays={requestDetails?.new_numberofworkdays}
          requireDocuments={requestDetails?.new_requiredocuments_Formatted}
          employeeComment={requestDetails?.new_employeecomment}
        />
        <RequestDetailsContainerDivider />
        <RequestDetailsApprovalContainer
          approvedStatus={requestDetails?.new_approvalstatus_Formatted}
          approvedBy={requestDetails?._new_approvalby_value_Formatted}
          approvalDate={requestDetails?.new_approvaldate}
          approvalComment={requestDetails?.new_approvalcomment}
          vacationStatus={requestDetails?.statuscode_Formatted}
        />
        <ButtonsContainer>
          <RequestDetailsCloseButton
            appearance={'secondary'}
            onClick={hideRequestPopup}
          >
            Close
          </RequestDetailsCloseButton>
          {isCancelDisplayed ? (
            <CancelButton onClick={showCancelPopup}>
              <CalendarCancelLight style={{ color: 'white' }} /> Cancel request
            </CancelButton>
          ) : null}
        </ButtonsContainer>
      </RequestDetailsContentContainer>
    </RequestDetailsContainerStyle>
  );
};
